import React from "react";
import { motion } from "framer-motion";
import { Container, Button, Eyebrow } from "@/components/kit";
import MaskedLines from "@/components/MaskedLines";
import HeroVisual from "@/components/HeroVisual";
import { fadeUp } from "@/lib/motion";

export default function Hero() {
  return (
    <section className="relative overflow-hidden pb-14 pt-28 sm:pb-20 sm:pt-36 md:pb-28 md:pt-44">
      <div className="pointer-events-none absolute inset-0 tech-grid radial-fade opacity-60" />
      <div className="pointer-events-none absolute -top-24 left-1/2 h-[320px] w-[480px] -translate-x-1/2 rounded-full bg-brand/[0.05] blur-[100px] sm:-top-40 sm:h-[560px] sm:w-[1000px] sm:blur-[140px]" />

      <Container className="relative">
        <div className="grid items-center [&>*]:min-w-0 gap-10 sm:gap-14 lg:grid-cols-[1.05fr_0.95fr]">
          <div>
            <motion.div variants={fadeUp} initial="hidden" animate="show">
              <Eyebrow>AI Trust · Security · Governance · Assurance</Eyebrow>
            </motion.div>

            <h1 className="mt-6 break-words font-display text-[34px] font-medium leading-[1.04] tracking-tight text-content [overflow-wrap:anywhere] sm:mt-8 sm:text-6xl md:text-[72px]">
              <MaskedLines lines={["Know your AI", "is safe."]} />
              <span className="mt-1 block text-gradient brand-glow">
                <MaskedLines lines={["Prove it to everyone else."]} startDelay={2} />
              </span>
            </h1>

            <motion.p
              variants={fadeUp}
              initial="hidden"
              animate="show"
              custom={4}
              className="mt-6 max-w-xl text-[16px] leading-relaxed text-content-muted sm:mt-8 sm:text-lg"
            >
              Meira AI tests AI systems for security risks, governs them against recognized
              standards, generates evidence, and turns that evidence into verifiable proof.
            </motion.p>

            <motion.div
              variants={fadeUp}
              initial="hidden"
              animate="show"
              custom={5}
              className="mt-8 flex max-w-xs flex-col items-stretch gap-3 sm:mt-9 sm:max-w-none sm:flex-row sm:flex-wrap sm:items-center sm:gap-4"
            >
              <Button to="/contact" variant="primary" data-testid="hero-book-demo" className="uppercase tracking-[0.12em]">
                Book a Demo
              </Button>
              <Button to="/platform" variant="outline" data-testid="hero-explore-platform">
                Explore the Platform
              </Button>
              <a
                href="/verify"
                data-testid="hero-verify"
                className="group inline-flex min-h-[44px] items-center justify-center gap-2 px-2 py-2 text-sm font-medium text-brand transition-colors hover:text-brand-soft sm:justify-start"
              >
                Verify a Certificate
                <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </a>
            </motion.div>
          </div>

          <HeroVisual />
        </div>
      </Container>
    </section>
  );
}
